<template>
  <div class="table-box setTable">
    <div class="tableBox">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" ref="table">
          <template slot-scope="{ row }" slot="status">
              <span v-if="row.status == '1'">已承保</span>
              <span v-if="row.status == '-1'">已退保</span>
              <span v-if="row.status == '0'">已终止</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <span class="table-btn" @click="openLookModal(row)">历史记录</span>
              <div class="table-btn" v-if="row.count==1 && row.btn4 && row.revisitUrl" @click="$units.copyUrl(row.revisitUrl, true)">复制回访链接</div>
              <div class="table-btn" v-if="row.count==1 && row.btn3 && row.receiptUrl" @click="$units.copyUrl(row.receiptUrl, true)">复制回执链接</div>
              <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row)"
                  v-if="showMoreBtn && !Number(row.settlementStatus) && row.sourceType != 1 || row.receiptUrl || row.revisitUrl">
                  <div class="table-btn" v-if="row.count>1">
                      更多
                      <Icon type="ios-arrow-down"></Icon>
                  </div>
                  <DropdownMenu slot="list">
                      <DropdownItem name="addreceiptStatus"
                          v-if="$units.pointAction('order_1_40_3') && !Number(row.settlementStatus) && row.sourceType != 1">
                          更新回执状态
                      </DropdownItem>
                      <DropdownItem name="addrevisitStatus"
                          v-if="$units.pointAction('order_1_40_4') && !Number(row.settlementStatus) && row.sourceType != 1">
                          更新回访状态
                      </DropdownItem>
                      <DropdownItem name="receiptUrl"
                          v-if="$units.pointAction('order_1_40_5') && row.receiptUrl">
                          复制回执链接
                      </DropdownItem>
                      <DropdownItem name="revisitUrl"
                          v-if="$units.pointAction('order_1_40_6') && row.revisitUrl">
                          复制回访链接
                      </DropdownItem>
                  </DropdownMenu>
              </Dropdown>
            </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center;" />
      </div>
      <Modal v-model="lookModal" title="回执回访记录" width="1000px" @on-cancel="cancelModal" :footer-hide="true">
          <Timeline v-if="recordList.length > 0">
              <TimelineItem v-for="(item, index) in recordList" :key="index">
                  <div class="statusGet">
                      <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="item.receiptStatus" v-if="item.receiptStatus">
                      </lzDicTxt>
                      <lzDicTxt dicType="VERIFY_STATUS" :dicCode="item.revisitStatus" v-if="item.revisitStatus">
                      </lzDicTxt>
                      <span v-if="item.remark">-{{ item.remark }}</span>
                  </div>
                  <div class="receiptContent">
                      <div>{{ item.updateTime | filterTime("YYYY-MM-DD") }}</div>
                      <div>
                          <span>更新人：</span><span>{{ item.updateName }}</span>
                      </div>
                      <div v-if="item.receiptUrl">回执链接 <a :href="item.receiptUrl" target="_blank">{{ item.receiptUrl }}
                          </a></div>
                      <div v-if="item.revisitUrl">回访链接 <a :href="item.revisitUrl" target="_blank">{{ item.revisitUrl
                      }}</a></div>
                  </div>
              </TimelineItem>
          </Timeline>
          <noData v-else />
      </Modal>
      <receiptStatus ref="receiptStatus" @refresh="getList()"></receiptStatus>
      <revisitStatus ref="revisitStatus" @refresh="getList()"></revisitStatus>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import filters from "@/api/filter";
import lzDicTxt from "@/components/commons/lzDicTxt";
import receiptStatus from "@/pages/orderManage/visitReceived/components/receiptStatus.vue";
import revisitStatus from "@/pages/orderManage/visitReceived/components/revisitStatus.vue";
export default {
  mixins: [common],
  components: {
    receiptStatus,
    revisitStatus,
    lzDicTxt
  },
  computed:{
    showMoreBtn() {
            if (this.$units.pointAction('order_1_40_3') || this.$units.pointAction('order_1_40_4') || this.$units.pointAction('order_1_40_5') || this.$units.pointAction('order_1_40_6')) {
                return true
            } else {
                return false
            }
        }
  },
  data(){
    return{
      tableLoading: false, //表格loading
      lookModal: false,
      recordList: [],
      columns:[
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 140
        },
        {
          title: '产品名称（产品编码）',
          key: 'productName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return <span>{params.row.productName}({params.row.productCode})</span>;
          },
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            if(params.row.insureTime){
              const res = filters.filterTime(params.row.insureTime,"YYYY-MM-DD")
              return (
                <span>{res}</span>
              );
            }else{
              return (
                <span class="red">缺失</span>
              );
            }
            
          },
        },
        {
          title: '犹豫期截止日',
          key: 'hesitateDate',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            if(params.row.hesitateDate){
              const res = filters.filterTime(params.row.hesitateDate,"YYYY-MM-DD")
              return (
                <span>{res}</span>
              );
            }else{
              return (
                <span>-</span>
              );
            }
          },
        },
        {
          title: '保费（元）',
          key: 'fee',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '保单状态',
          slot: 'status',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '最新回执回访时间',
          key: 'createTime',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            if(params.row.createTime){
              const res = filters.filterTime(params.row.createTime,"YYYY-MM-DD")
              return (
                <span>{res}</span>
              );
            }else{
              return (
                <span>-</span>
              );
            }
          },
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.receiptStatus == '-1') {
              return <span>无需回执</span>;
            } else if (params.row.receiptStatus == '0') {
              return <span>待回执</span>;
            } else if (params.row.receiptStatus == '1') {
              return <span>回执成功</span>;
            } else if (params.row.receiptStatus == '2') {
              return <span>回执失败</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
        title: "回访状态",
        align: "center",
        minWidth: 100,
        tooltip: true,
        render(h, params) {
          const revisitStatus = params.row.revisitStatus;
          if (revisitStatus === 0 || revisitStatus === "0") {
            return <span>等待回访</span>;
          } else if (revisitStatus == 1) {
            return <span>回访成功</span>;
          } else if (revisitStatus == 2) {
            return <span>回访失败</span>;
          } else if (revisitStatus == 3) {
            return <span>无需回访</span>;
          } else {
            return <span>-</span>;
          }
        },
      },
        {
          title: '出单业务员',
          key: 'salermanName',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '投/被保险人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName
                ? params.row.holderName + "/" + params.row.insuranceName
                : params.row.holderName;
              return (
                  <div>{res}</div>
              );
          },
        },
        {
          title: '操作',
          slot: 'action',
          width: 170,
          align: 'center',
          fixed:'right',
        },
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 5, //页容量
      pageNum: 1, //当前页

    }
  },
  methods:{
    cancelModal() {
        this.recordList = []
    },
    // 更多操作中的方法
    dropdownClick(e, item) {
        if (e == 'addreceiptStatus') {
            this.$refs.receiptStatus.open(item)
        } else if (e == 'addrevisitStatus') {
            this.$refs.revisitStatus.open(item)
        } else if (e == 'receiptUrl') {
            this.$units.copyUrl(item.receiptUrl, true);
            this.$units.getHealthTest('order_1_40_5')
        } else if (e == 'revisitUrl') {
            this.$units.copyUrl(item.revisitUrl, true);
            this.$units.getHealthTest('order_1_40_5')
        }
    },
    // 查看历史记录
    openLookModal(item) {
        this.lookModal = true
        this.$http({
            url: '/buz/policyReceiptRecord/read/detail',
            type: "GET",
            data: {
                policyNo: item.policyNo || '',
            }
        })
            .then((res) => {
                this.recordList = res.data
            })
    },
    // 获取列表数据
    getList() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/workBenches/noReceiptRevisit/list',
        type: 'post',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
          this.tableData.forEach((item)=>{
            item.count = 0
            if(this.$units.pointAction('order_1_40_3') && !Number(item.settlementStatus) && item.sourceType != 1){
              item.count = item.count+1
              item.btn1=true
            }
            if(this.$units.pointAction('order_1_40_4') && !Number(item.settlementStatus) && item.sourceType != 1){
              item.count = item.count+1
              item.btn2=true
            }
            if(this.$units.pointAction('order_1_40_5') && item.receiptUrl){
              item.count = item.count+1
              item.btn3=true
            }
            if(this.$units.pointAction('order_1_40_6') && item.revisitUrl){
              item.count = item.count+1
              item.btn4=true
            }
          })

        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  },
  mounted(){
    this.getList()
  }
}
</script>

<style lang="scss" scoped>

.table-box{
  padding-bottom: 10px;
}
</style>